var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-screen flex w-full bg-img" }, [
    _c(
      "div",
      {
        staticClass:
          "vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center",
      },
      [
        _c("img", {
          staticClass: "mx-auto mb-4 max-w-full",
          attrs: {
            src: require("../../assets/images/pages/404.png"),
            alt: "graphic-404",
          },
        }),
        _c(
          "h1",
          {
            staticClass: "sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color",
            staticStyle: { color: "white" },
          },
          [_vm._v("Ups")]
        ),
        _c(
          "h2",
          { staticClass: "sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse" },
          [
            _vm._v(
              "Lo sentimos. Nuestra plataforma tuvo un inconveniente y estamos trabajando para repararlo. Inténtalo más tarde o comunícate con nuestra línea de servicio al cliente:"
            ),
          ]
        ),
        _c(
          "h1",
          { staticClass: "sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse" },
          [_vm._v("+57 312 7761645")]
        ),
        _c("vs-button", { attrs: { size: "large", to: "/" } }, [
          _vm._v("Volver al inicio"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }